<template>
  <label :for="`file_uploader_${id}`">
    {{ $t('common.imageSelector.selectFromLocal') }}
    <input :id="`file_uploader_${id}`" class="input" type="file" @change="onFileChange" />
  </label>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    prefix: String,
  },
  data() {
    return {
      id: null,
      imageData: null,
    };
  },
  mounted() {
    this.id = this._uid;
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const fileName = `${this.prefix}/${file.name}`;

        // await image.upload(fileName, file, file.type);
        const tgt = event.target as FileReader;
        const image = tgt.result as string;

        // const data = resizeImage.resize(image, 200, 100, resizeImage.PNG);

        this.$emit("update:file", { fileName, data: image });
      };
      reader.readAsDataURL(file);
    },
  },
});
</script>

<style lang="scss" scoped>
.input {
  display: none;
}

label {
  text-align: center;
  line-height: 50px;
}
</style>
